import React from 'react';
import ModernTagsComponent from '../modern-tags';
import { TagsComponentProps } from './types';

function TagsComponent(props: TagsComponentProps) {
    return <ModernTagsComponent {...props} />;
}

TagsComponent.defaultProps = {
    locked: false,
};

export default TagsComponent;
